import React from 'react';
import {
  Box,
  FormControl,
  FormLabel,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import { SALON_PUBLIC_TEMPLATE_KEYS } from '../../../theme/salonPublicTemplates';
import SalonTemplateCard from './SalonTemplateCard';


const SalonThemeFeaturedTemplates = ({
  value,
  disabled = false,
  onChange,
  focusRef,
}) => {
  const { t } = useTranslation();
  const chooseStyle = t('salon_theme.essential.choose_style');

  return (
    <FormControl
      component="fieldset"
      fullWidth
      data-testid="salon-theme-template-gallery"
      style={{
        '--salon-theme-gallery-container-type': 'inline-size',
        '--salon-theme-gallery-two-column-min': '240px',
        '--salon-theme-gallery-three-column-min': '420px',
      }}
      sx={{ containerType: 'var(--salon-theme-gallery-container-type)' }}
    >
      <FormLabel component="legend" sx={{ mb: 1.5, fontWeight: 800 }}>
        {chooseStyle}
      </FormLabel>
      <Box
        role="radiogroup"
        aria-label={chooseStyle}
        data-testid="salon-theme-template-grid"
        sx={{
          display: 'grid',
          gridTemplateColumns: 'minmax(0, 1fr)',
          '@container (min-width: 240px)': {
            gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
          },
          '@container (min-width: 420px)': {
            gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
          },
          gap: 1,
          minWidth: 0,
        }}
      >
        {SALON_PUBLIC_TEMPLATE_KEYS.map((templateKey) => (
          <SalonTemplateCard
            key={templateKey}
            templateKey={templateKey}
            selected={templateKey === value}
            disabled={disabled}
            compact
            onSelect={onChange}
            inputRef={templateKey === value ? focusRef : undefined}
          />
        ))}
      </Box>
    </FormControl>
  );
};

export default SalonThemeFeaturedTemplates;
